import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-text-search',
  templateUrl: './text-search.component.html',
  styleUrls: ['./text-search.component.scss']
})
export class TextSearchComponent implements OnInit {
  @Input() searchQuery: string;

  examples: Array<any> = [
    { 'type': 'string', 'query': 'CA-370-207', 'label': 'drug search', 'description': 'CA-370-207' },
    { 'type': 'string', 'query': 'ODDBTXQEKZMYOK', 'label': 'InChI key search', 'description': 'ODDBTXQEKZMYOK (CA-370-220)' },
  ]

  constructor(private router: Router) { }

  ngOnInit() {
  }

  onSubmit() {
    this.router.navigate(['search'], {
      queryParams:
        { query: this.searchQuery,
          type: 'string'}
    });
  }

}
